var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThinArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.75,
    height: 15,
    viewBox: "0 0 20.75 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thin-arrow",
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25523",
    "data-name": "Path 25523",
    d: "M18.431-435.393a.672.672,0,0,1,.456.381c.193.368.1.607-.553,1.494a17.936,17.936,0,0,1-5,4.6l-.435.264,7.778.008c7.765.013,7.782.013,7.929.1a.749.749,0,0,1,0,1.289c-.147.088-.163.088-7.929.1l-7.782.008.373.222a18.019,18.019,0,0,1,5.224,4.856c.381.54.481.745.486.95a.878.878,0,0,1-.335.62.552.552,0,0,1-.427.084c-.356-.021-.44-.08-.749-.536a16.747,16.747,0,0,0-4.09-4.132,13.881,13.881,0,0,0-4.6-2.106.678.678,0,0,1-.481-.394.709.709,0,0,1,0-.636c.113-.247.264-.335.925-.519a14.237,14.237,0,0,0,6.283-3.78,15.6,15.6,0,0,0,1.725-2.018c.5-.7.527-.728.649-.791A.889.889,0,0,1,18.431-435.393Z",
    transform: "translate(-8.225 435.411)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinArrow);
export default __webpack_public_path__ + "static/media/thin-arrow.0d55fe88b2af0fec22b7428c6e98e25a.svg";
export { ForwardRef as ReactComponent };